export default "__VITE_ASSET__SWt4Ra7m__"